<template>
    <!-- BEGIN: Content-->
    <div>
      <CommonTable
          v-show="listing"
          :url="url"
          :tableHeaderValues="tableHeaderValues"
          :actions="actions"
          :deleteActions="deleteActions"
          :mutedData="mutedData"
          :storageKey="storageKey"
          :externalTotalRecord="externalTotalRecord"
          :filteredData="filteredData"
          :showPerPage = true
          :exportData="exportData"
          :showJsonExportButton="true"
          @getFullResponse="getFullResponse"
          :hideAllPerPage="true"
      />
      <GatewayDetails :rowData="rowData" v-if="!listing" @backFromDetailPage="backFromDetailPage" />
      
      <TransactionChargesModal :show="showChargesModal" :data="chargesData"
                                    @hide="showChargesModal = false"
  
      />
  
  
      <RefundModal :show="showRefundModal" :transactionId="transactionId"
                   :refundInitialAmount="refundInitialAmount"
                   @hide="showRefundModal = false"></RefundModal>
  
      <CardDetailsModal :show="showCardModal" :transactionId="transactionId"
  
                   @hide="showCardModal = false"></CardDetailsModal>
  
      <DirectCreditModal :show="showDirectCreditModal" :transactionId="transactionId"
                   :refundInitialAmount="refundInitialAmount"
                   @hide="showDirectCreditModal = false"></DirectCreditModal>
  
      <ExchangeDetailModal
        :exchangeData="exchangeData"
        :show="showExchangeData"
        @hide="showExchangeData = false"
      ></ExchangeDetailModal>
  
      <ProcessModal :show="showConfirmationModal" @confirm="confirm" message="Are you sure to proceed?"
                    title="Check Gateway Settlement Status"
                    :loader="confirmationModalLoader"
                    @hide="showConfirmationModal = false"></ProcessModal>
  
    </div>
    <!-- END: Content-->
  </template>
  
<script>
import TransactionChargesModal from "@/pages/dashboard/transactions/TransactionChargesModal";
import RefundModal from "@/pages/dashboard/transactions/RefundModal";
import ExchangeDetailModal from "@/pages/dashboard/transactions/ExchangeDetailModal";
import DirectCreditModal from "@/pages/dashboard/transactions/DirectCreditModal";
import CardDetailsModal from "@/pages/dashboard/transactions/CardDetailsModal";
import GatewayDetails  from "@/pages/dashboard/stats/GatewayDetailsVol";

export default {
  props:['filter'],
  components:{
    CardDetailsModal,
    TransactionChargesModal,
    RefundModal,
    ExchangeDetailModal,
    DirectCreditModal,
    GatewayDetails

  },
  mounted() {
    localStorage.setItem("url", "v1/get-transaction");
    this.checkDataInStore('v1/get-transaction')
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
  },
  data() {
    return {
      listing: true,
      rowData: [],
      showConfirmationModal: false,
      showCardModal: false,
      confirmationModalLoader: false,
      exchangeData:{},
      showExchangeData:false,
      currentPage: 1,
      showRefundModal:false,
      showDirectCreditModal:false,
      transactionId:'',
      exportData:{
        cta: (exportType) => {
          let requestData = {
            ...this.filteredData,
            exportAs: exportType,
            reportType: 'transaction',
           

          }
          this.downloadReport(requestData)

        }
      },
      showChargesModal: false,
      chargesData: [],
      url: "v1/get-transaction",
      storageKey: "transactions",
      isDefault: false,
      tableHeaderValues: [
        {
          title: "Transaction Id",
          valueKey: "uuid",
          html: true,
          alter: (value,row) => {
            var html = "";
            if (value) {
              if(row.application == 'DIRECT_API_PAYMENT'){
                html = `
                <div class="row">
                    <div class="col-12 text-center">
                        <div class=""><span class="text-primary font-weight-bolder" style="cursor: pointer">${value}</span></div>
                        <div class="badge badge-light-info mt-1">Direct Api Payment</div>
                    </div>
                </div>
                `

              }else{
                html = `<span class="text-primary font-weight-bolder" style="cursor: pointer">${value}</span>`
              }

              return html;
            } else {
              html = "-";
              return html;
            }
          },
          cta: (row) => {
            this.copyText(row.uuid);
            this.$router.push({name: 'transactions-detail',params: {id:row.uuid}})
          }
        },
        {
          title: "Gateway Reference Id",
          valueKey: "gateway_reference_id",
          html: true,
          alter: function(value) {
            var html = "";
            if (value) {
              html = `<span class="text-info" title="Click To Copy" style="cursor: pointer">${value}</span>`;
              return html;
            } else {
              html = "-";
              return html;
            }
          },
          cta: (row) => {
            if(row.gateway_reference_id){
              this.copyText(row.gateway_reference_id);
            }

          }
        },
        {
          title: "Gateway Settlement Status",
          valueKey: "gateway_reference_id",
          html: true,
          alter: (value,row) => {
            var html = "N/A";
            if(typeof(row.gw_settlement_status) != 'undefined'){
              if (row.gw_settlement_status != null) {
                var updated_at = ''
                if(row.gw_settlement_status_update_at != null){
                  updated_at = `<div class="" ><span class="badge-light-success badge ">${this.customFormatDateTime(row.gw_settlement_status_update_at)}</span></div>`
                }
                html = `
                <div class="row">
                    <div class="col-12 ">
                        <div class=""><span class="badge-light badge text-primary">${row.gw_settlement_status==1?"Transmitted":"Not Transmitted"}</span></div>
                        ${updated_at}
                    </div>
                </div>
                `

              }
            }
            return html;
          },

        },
        {
          title: "Reference Id",
          valueKey: "reference_id",
          html: true,
          alter: function(value) {
            var html = "";
            if (value) {
              html = `<span class="text-dark" title="Click To Copy"  style="cursor: pointer">${value}</span>`;
              return html;
            } else {
              html = "-";
              return html;
            }
          },
          cta: (row) => {
            if(row.reference_id){
              this.copyText(row.reference_id);
            }

          }
        },
        {
          title: "Sender Account Number",
          valueKey: "sender_account_number",
          html: true,
          alter: function(value) {
            if (!value) {
              return "-";
            } else {
              return value;
            }
          }
        },
        {
          title: "Sender Account Title",
          valueKey: "sender_account_title",
          html: true,
          alter: function(value) {
            if (!value) {
              return "-";
            } else {
              return `<a href="javascript:void()" class="badge badge-glow badge-dark">${value}</a>`;
            }
          }
        },
        {
          title: "Receiver Account Number",
          valueKey: "receiver_account_number",
          alter: function(value) {
            if (!value) {
              return "-";
            } else {
              return value;
            }
          }
        },
        {
          title: "Reciever Account Title",
          valueKey: "receiver_account_title",
          html: true,
          alter: function(value) {
            if (!value) {
              return "-";
            } else {
              return `<a href="javascript:void()" class="badge badge-glow badge-info">${value}</a>`;
            }
          }
        },
        {
          title: "Payment Method",
          valueKey: "payment_method.name",
          html: true,
          alter: function(value) {
            if (!value) {
              return "-";
            } else {
              return `<a href="javascript:void()" class="badge badge-glow badge-primary">${value}</a>`;
            }
          }
        },
        {
          title: "Channel",
          valueKey: "channel",
          alter: function(value) {
            if (!value) {
              return "-";
            } else {
              return value.name;
            }
          }
        },
        {
          title: 'Currency',
          valueKey: 'currency.code',
          html: true,
          alter: (value,row) => {
            var html = "";
            if (value) {
              if(row.exchange_details){
                if(row.transaction_type_id == 4){
                  html = `
                <div class="row">
                    <div class="col-12 ">
                        <div class="badge-success badge badge-glow">${value}</div>
                        <div class="badge badge-light-primary mt-1">${'exchange with '+ row.exchange_details.to_currency}</div>
                    </div>
                </div>
                `

                }else{
                  html = `
                <div class="row">
                    <div class="col-12 ">
                        <div class="badge-success badge badge-glow">${value}</div>
                        <div class="badge badge-light-primary mt-1">${'processed in '+ row.exchange_details.to_currency}</div>
                    </div>
                </div>
                `
                }


              }else{
                html = `<div class="row">
                    <div class="col-12 ">
                        <div class="badge-success badge badge-glow">${value}</div>

                    </div>
                </div>`
              }

              return html;
            } else {
              html = "-";
              return html;
            }
          },
        },
        {
          title: 'Actual Amount',
          valueKey: 'amount',
          html: true,
          alter: (value,row) => {
            var html=''
            if (row.total_amount != value)
              html = `<div  class="font-lg-4 font-weight-bolder text-dark">${this.modifyAmount(parseFloat(row.total_amount / 100).toFixed(this.amountDecimalPlaces))}</div>`
            else
              html = `<div  class="font-lg-4 font-weight-bolder text-dark">${this.modifyAmount(parseFloat(value/100).toFixed(this.amountDecimalPlaces))}</div>`


            return  html


          }
        },
        {
          title: 'Vat',
          valueKey: 'vat',
          html: true,
          alter: (value,row) => {
            var html=''

            html = ` <div  class="  text-dark">${parseFloat(value / 100).toFixed(this.feesDecimalPlaces)}</div>`


            return  html
          }
        },
        {
          title: 'Fees',
          valueKey: 'fee',
          html: true,
          alter: (value,row) => {
            var html=''

            html = ` <div  class="  text-dark">${parseFloat(value / 100).toFixed(this.feesDecimalPlaces)}</div>`


            return  html

          }
        },
        {
          title: 'Payable Amount',
          valueKey: 'amount',
          html: true,
          alter: (value,row) => {
            var html=''
            if (row.transaction_type_id == 6) {
              html = ` <div  class=" font-weight-bolder text-danger">- ${this.modifyAmount(parseFloat((parseFloat(value)+parseFloat(row.vat)+parseFloat(row.fee))/100).toFixed(this.amountDecimalPlaces))}</div>`
              return html
            }
            if (row.total_amount != value)

              html = ` <div  class=" font-weight-bolder text-dark">${this.modifyAmount(parseFloat((value)/100).toFixed(this.amountDecimalPlaces))}</div>`
            else
              html = ` <div  class=" font-weight-bolder text-dark">${this.modifyAmount(parseFloat((value-row.vat-row.fee)/100).toFixed(this.amountDecimalPlaces))}</div>`

            return  html


          }
        },
        {
          title: "Processed Amount",
          valueKey: "uuid",
          html: true,
          alter: (value,row) => {
            var html = "";
            if (row.exchange_details) {
              html = `
                <div class="row">
                    <div class="col-12 ">
                        <div class=""><span class="font-weight-bolder  text-primary">${this.modifyAmount(this.calculateProcessedAndExchangeRateAmountForList(row))}</span></div>
                        <div class=""><span class="badge-light-success badge ">${row.exchange_details.to_currency}</span></div>
                    </div>
                </div>
                `

              return html;
            } else {
              html = "-";
              return html;
            }
          },
          cta: (row) => {
            this.$router.push({name: 'transactions-detail',params: {id:row.uuid}})
          }
        },
        {
          title: 'Exchange Rate',
          valueKey: 'exchange_rate',
          html: true,
          alter: (value,row) => {
            var html='-'
            if(value)
              html = ` <div  class=" font-weight-bolder text-dark">${parseFloat(value).toFixed(this.amountDecimalPlaces)}</div>`
            else{
              if (row.exchange_details) {
                html = ` <div  class=" font-weight-bolder text-dark">${this.calculateProcessedAndExchangeRateAmountForList(row,true)}</div>`
              }
            }


            return  html


          }
        },
        {
          title: "Created Date / Time",
          titleHtml: `<span class="text-warning font-weight-bolder">
                                                        (Showing In GMT)
                                                    </span>`,
          valueKey: "created_at",
          html: true,
          alter: (value,row) => {
            var html='-'
            if(value)
              html = ` <div  class=" font-weight-bolder text-dark">${new Date(value).toISOString().slice(0, 16).replace('T', ' ')}</div>`



            return  html


          }
          //     alter: (value) => {
          //   // return this.customFormatDateTime(value)
          //       return new Date(value).toISOString().slice(0, 16).replace('T', ' ')
          // }
        },
      ],
      actions: [
        {
          title: "Charges",
          class: "btn-primary mt-1  ml-sm-50",
          cta: (row, index) => {
            this.chargesData = row
            this.showChargesModal = true
            // let data = {
            //   index: index,
            //   row: row,
            //   key: "charges"
            // };
            // this.$store.dispatch("set", data);
          }
        },
        {
          title: "Details",
          class: "btn-info mt-1  ml-sm-50",
          cta: (row, index) => {

            let propFilters = this.filter
            propFilters.currentPage = this.currentPage
            propFilters.tabToShow = 1

            this.$router.push({name: 'transactions-detail',params: {id:row.uuid,propFilters: propFilters}})
            // this.$emit('getRowData',row)



            // let data = {
            //   index: index,
            //   row: row,
            //   key: "transactionDetails"
            // };
            // this.$store.dispatch("set", data);
            // this.$router.push({name:'transactions-detail'})
          }
        },
        {
          title: "Gateway",
          class: "btn-warning mt-1  ml-sm-50",
          cta: (row, index) => {
            // this.$emit('getGatewayRowData',row)
            this.$emit('gateway',false)
            this.rowData = row
            this.listing = false
           
          }
        },
        {
          title: "Card",
          class: "btn-primary mt-1  ml-sm-50",
          cta: (row, index) => {

            // let propFilters = this.filter
            // propFilters.currentPage = this.currentPage
            // propFilters.tabToShow = 1
            //
            // this.$router.push({name: 'transactions-card-detail',params: {transactionStatus:'normal',id:row.uuid,propFilters: propFilters}})
            this.transactionId = row.uuid
            this.showCardModal = true
          }
        },
        {
          title: 'Refund',
          class: "btn-danger mt-1  ml-sm-50",
          cta: (row) => {
            this.transactionId = row.uuid
            this.refundInitialAmount = parseFloat(row.total_amount/100).toFixed(this.amountDecimalPlaces)
            this.showRefundModal = true
          }
        },
        {
          title: 'Direct Credit',
          class: "badge badge-success  mt-1  ml-sm-50",
          cta: (row) => {
            this.transactionId = row.uuid
            this.refundInitialAmount = parseFloat(row.total_amount/100).toFixed(this.amountDecimalPlaces)
            this.showDirectCreditModal = true
          }
        },
        {
          title: 'Exchange',
          class: "btn-primary mt-1  ml-sm-50",
          conditionalRendering: true,
          condition: (row)=>{
            if(row.exchange_details){
              return true
            }
            return false
          },
          cta: (row) => {
            this.exchangeData = {}
            if(row.exchange_details){
              this.exchangeData = row
            }
            this.showExchangeData = true
          }
        },
        // {
        //   title: "Check Gateway Settlement Status",
        //   class: "badge badge-secondary mt-1  ml-sm-50 ",
        //   cta: (row, index) => {
        //     this.transactionId = row.uuid
        //     this.showConfirmationModal = true
        //   },
        //   conditionalRendering: true,
        //   condition: (row)=>{
        //     if(typeof(row.gw_settlement_status) != 'undefined'){
        //       if (row.gw_settlement_status != null && row.gw_settlement_status == 1) {
        //         return false
        //       }
        //     }
        //     return true
        //   },
        // },
      ],
      deleteActions: [],
      mutedData: [],
      externalTotalRecord: "",
      filteredData:{status:1},
      transactionChargesTable: {
        header: [
          {
            title: 'UUID'
          },
          {
            title: 'Receiver Account Title'
          },
          {
            title: 'Sender Account Title'
          },
          {
            title: 'Amount'
          },
        ],
        body: {
          getData: (row) => {
            let finalData = []
            let temp = []
            if(row?.charges_transactions){
              for (let [key, value] of Object.entries(row.charges_transactions)) {
                let temp = []
                temp.push(value.uuid)
                temp.push(value.receiver_account_title)
                temp.push(value.sender_account_title)
                temp.push(parseFloat(value.amount/100).toFixed(this.amountDecimalPlaces))
                finalData.push(temp)
              }
            }
            return finalData
          }
        },
      },
      refundInitialAmount:''
    };
  },
  methods: {
    backFromDetailPage(){
      this.$emit('gateway',true)
      /*close accordian*/
      var elems = document.querySelectorAll(".collapse");

      [].forEach.call(elems, function(el) {
        el.classList.remove("show");
      });
      this.listing = true
    },
    
    confirm() {
      this.confirmationModalLoader = true
      this.makeRequest("post", "v1/process-pending-transaction", {transactionId:this.transactionId,gatewaySettlementStatus:1}).then(
          callResponse => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                this.showConfirmationModal = false
              }
            }
            this.transactionId = ''
            this.confirmationModalLoader = false
            this.showConfirmationModal = false
          }
      );

    },
    getFullResponse(response) {
      this.$emit('dataFetched',response)
      if (typeof (response.fullResponse) != 'undefined') {
        let data = response.fullResponse
        this.currentPage = data.paginationData.currentPage
        delete this.filteredData.page
      }
    }
  },
  watch:{
    filter: {
      // the callback will be called immediately after the start of the observation
      immediate: true,
      handler (val, oldVal) {
        let temp = val
       
        this.filteredData = temp
      }
    }
  }
};
</script>
  